import React from 'react';
import { ResourceField, ResourceFormPage } from '../../components/resource/ResourceFormPage';
import { Entidade } from '../../types/pessoas';
import {
  entidadesService,
  tiposEntidadeService,
  enderecosService,
} from '../../services';
import { makeOptionLoader } from '../../utils/optionLoaders';

const fields: ResourceField<Entidade>[] = [
  {
    name: 'tipo_pessoa',
    label: 'Tipo de pessoa',
    type: 'select',
    options: [
      { label: 'Pessoa Jurídica', value: 'PJ' },
      { label: 'Pessoa Física', value: 'PF' },
    ],
    required: true,
  },
  { name: 'documento', label: 'Documento (CPF/CNPJ)', required: true, helperText: 'CPF (11 dígitos) ou CNPJ (14 dígitos) - apenas números' },
  { name: 'razao_social', label: 'Razão social', required: true },
  { name: 'nome_fantasia', label: 'Nome fantasia' },
  { name: 'inscricao_estadual', label: 'Inscrição estadual' },
  { name: 'inscricao_municipal', label: 'Inscrição municipal' },
  { name: 'suframa', label: 'SUFRAMA' },
  { name: 'cnae', label: 'CNAE' },
  { name: 'email', label: 'E-mail', type: 'email' },
  { name: 'telefone', label: 'Telefone', required: true, helperText: 'Telefone com ou sem formatação' },
  { name: 'telefone_secundario', label: 'Telefone secundário', helperText: 'Telefone com ou sem formatação' },
  {
    name: 'endereco',
    label: 'Endereço',
    type: 'async-select',
    valueType: 'number',
    loadOptions: makeOptionLoader(
      enderecosService.list,
      (item: any) => {
        const partes = [item.logradouro, item.bairro, item.cidade_nome, item.cep].filter(Boolean);
        return partes.length ? partes.join(', ') : `Endereço #${item.id}`;
      },
    ),
  },
  { name: 'numero', label: 'Número', helperText: 'Número do endereço' },
  {
    name: 'tipos',
    label: 'Tipos de entidade',
    type: 'async-select',
    multiple: true,
    valueType: 'number[]',
    loadOptions: makeOptionLoader(
      tiposEntidadeService.list,
      (item: any) => item.descricao ?? item.codigo ?? String(item.id),
    ),
    helperText: 'Selecione CLIENTE, FORNECEDOR, COLABORADOR etc.',
  },
  { name: 'observacoes', label: 'Observações', type: 'textarea' },
];

export const EntidadesFormPage: React.FC = () => (
  <ResourceFormPage
    title="Nova entidade"
    description="Cadastre entidades base para clientes, fornecedores e colaboradores."
    fields={fields}
    service={entidadesService}
    redirectPath="/admin/pessoas/entidades"
    cancelPath="/admin/pessoas/entidades"
  />
);
